import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import { Button, Grid, Link, Tooltip } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { withStyles } from "@material-ui/core/styles";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import AdjuntarIcon from "@material-ui/icons/AttachFileOutlined";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";

import { useStateValue } from "../../context/store";

import RefundUploadFilesModal from "./refundUpdloadFilesModal";
import { dowloadReportAsync, getRefundByRecomendationDocumentsAsync } from "../../actions/refund-recommendation-actions";
import { permissionsConstans } from "../../constansPermissions";
import moment from "moment";


const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "39.6%",
  },
  columnEvent: {
    paddingLeft: "20px",
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    width: "165px",
    "&:hover": { color: "white", background: "#099F9F" },
  },
}));


const RefundAccordion = (props) => {
  const {
    headers,
    data,
    handleCancel,
    handleFinalize,
    maestras
  } = props;

  const classes = useStyles();
  const [{ }, dispatch] = useStateValue();
  const id = IdKey.generate();
  const [showDetails, setShowDetails] = useState(false);
  const [documents, setDocuments] = useState([]);

  const getValueByKey = (object, header) => {
    if (header.child === null) {
      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }

        if (header.field === "status") {
          return object[header.field]
            ?.replaceAll("_", " ")
            .replace("cion", "ción");
        }
        if (header.field === "creationDate" || header.field === "initRefundDate" || header.field === "endRefundDate") {
          let fechaFormato = object[header.field];
          var fecha = fechaFormato ? fechaFormato.split("T")[0] : null;
          return fecha ? moment(fecha).format("DD/MM/YYYY") : null;
        }

        return object[header.field];
      }
      return "";
    }
    if (header.child === "regional") {
      return object[header.field] !== null
        ? object[header.field][header.child]["name"]
        : "";
    }
    return object[header.field] !== null
      ? object[header.field][header.child]
      : "";
  };

  const getDocumentsAsync = async (id) => {
    const response = await getRefundByRecomendationDocumentsAsync(id);
    if (response?.status === 200 || response?.status === 201) {
      if (response?.data) {
        setDocuments(response?.data);
      } else {
        setDocuments([]);
      }
    } else {
      setDocuments([]);
    }
  }


  const handleShowDetails = async () => {
    await getDocumentsAsync(data?.id);
    setShowDetails(true);
  }


  const showDetailsButton = (id) => {
    return !showDetails && (
      <Tooltip title="Ver detalle" arrow placement="top">
        <VisibilityIcon
          onClick={() => handleShowDetails(id)}
          style={{ fontSize: 40, pointerEvents: "auto" }}
          className={classes.iconEvent} />
      </Tooltip>
    )
  }

  const hideDetailsButton = () => {
    return showDetails && (
      <Tooltip title="Ocultar detalle" arrow placement="top">
        <VisibilityOffIcon
          onClick={() => setShowDetails(false)}
          style={{ fontSize: 40, pointerEvents: "auto" }}
          className={classes.iconEvent} />
      </Tooltip>
    )
  }

  //Modal Add files
  const [openModal, setOpenModal] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const handleClickClose = () => {
    setShowMessage(false);
  };

  const [message, setMessage] = useState({
    description: '',
    textButtonSubmit: '',
    handleClick: () => handleClickClose(),
    oneButtons: true,
    type: 'WARNING',
    open: false
  });


  const handleUploadFiles = (id) => {
    setOpenModal(true);
  }

  const showUploadFilesButton = (id, status) => {
    return (
      status !== "ANULADA" && <Tooltip title="Adjuntar archivos" arrow placement="top">
        <AdjuntarIcon
          onClick={() => handleUploadFiles(id)}
          style={{ fontSize: 40, pointerEvents: "auto" }}
          className={classes.iconEvent}
        />
      </Tooltip>
    )
  }

  const onClose = (accept) => {
    handleShowDetails();
    setOpenModal(false);
  };

  function downloadExam(pdf) {
    const format = pdf?.format.toLowerCase();
    const formatPdf = format === 'pdf' || format === 'application/pdf'
      ? 'pdf'
      : format === 'image/jpeg' || format === 'jpeg'
        ? 'jpeg'
        : format === 'image/png' || format === 'png'
          ? 'png'
          : 'jpg'
    const url = `data:@file/${formatPdf};base64,${pdf?.data}`;
    const downloadLink = document.createElement("a");
    const fileName = `${pdf?.name ?? 'file'}`;

    downloadLink.href = url;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const isEmptyDownload = (text) => {
    setMessage({
      description: `No hay ${text} para descargar.`,
      textButtonSubmit: "Aceptar",
      handleClick: () => handleClickClose(),
      type: "WARNING",
      threeButtons: false,
      oneButtons: true,
      open: true,
    });
  }

  const returnMessageError = (response, msj) => {
    setMessage({
      description: response?.data?.detail
        ? response?.data.detail
        : msj,
      textButtonSubmit: "Aceptar",
      handleClick: () => handleClickClose(),
      type: "WARNING",
      threeButtons: false,
      oneButtons: true,
      open: true,
    });
  }

  const getFileByDownload = async (id, file) => {
    const response = await dowloadReportAsync(id, file.saeDocumentId);
    if (response?.status === 200 || response?.status === 201) {
      if (response?.data?.data) {
        downloadExam(response?.data);
      } else {
        isEmptyDownload('archivos')
      }
    } else {
      const msj = 'Ocurrió un error procesando la solicitud, inténtelo nuevamentes'
      returnMessageError(response, msj);
    }
  }

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  const validationPermissionFinalize = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "REF_REC");
    const havePermission = module?.functionalities?.some((x) => x === permissionsConstans.REF_REC_FINALIZAR);
    const showButton = !(data?.status === "Finalizado" || data?.status === "Anulado") && havePermission
    return showButton && (
      <Grid item xs={2}>
        <Button
          variant="contained"
          className={classes.buttonSearch}
          onClick={() => handleFinalize(data?.id)}
        >
          Finalizar
        </Button>
      </Grid>
    )

  };

  const validationPermissionReject = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "REF_REC");
    const havePermission = module?.functionalities?.some((x) => x === permissionsConstans.REF_REC_ANULAR);
    const showButton = !(data?.status === "Finalizado" || data?.status === "Anulado") && havePermission
    return showButton && (
      <Grid item xs={2}>
        <Button
          variant="contained"
          className={classes.buttonSearch}
          onClick={() => handleCancel(data?.id)}
        >
          Anular
        </Button>
      </Grid>
    )

  };

  return (
    <div className={classes.root}>
      <Accordion
        style={{
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
        }}
        expanded={showDetails}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          expandIcon={<ExpandMoreIcon />}
          style={{ pointerEvents: "none" }}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header.title}
              </Typography>
              <Typography className={classes.secondaryHeading}>
                {getValueByKey(data, header)}
              </Typography>
            </div>
          ))}
          <div className={classes.columnEvent}>
            &nbsp;&nbsp;
            {showUploadFilesButton(data?.id, data?.status)}
            &nbsp;&nbsp;
            {showDetailsButton(data.id)}
            &nbsp;&nbsp;
            {hideDetailsButton()}
          </div>
        </FlippedOrderExpansionPanelSummary>
        <AccordionDetails className={classes.details}>

          {showDetails && (
            <>
              <div className={classes.rootGrid}>
                <Grid container spacing={3}>
                  {headers.otherHeaders.map((header) => (
                    <Grid item xs={2}>
                      <Typography className={classes.heading}>
                        {header.title}
                      </Typography>
                      <Typography className={classes.secondaryHeading}>
                        {getValueByKey(data, header)}
                      </Typography>
                    </Grid>
                  ))}
                  <Grid item xs={4}>
                    &nbsp;
                  </Grid>
                  <Grid item xs={2}>
                    {validationPermissionFinalize()}
                  </Grid>
                  <Grid item xs={2}>
                    {validationPermissionReject()}
                  </Grid>

                </Grid>

                <Grid container spacing={3}>
                  {documents && documents.map((doc) => (
                    <>
                      <Grid item xs={2}>
                        <Typography className={classes.heading}>
                          Fecha Inicial
                        </Typography>
                        <Typography className={classes.secondaryHeading}>
                          {doc?.initRefundDate ? doc?.initRefundDate.split(" ")[0] : null}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography className={classes.heading}>
                          Fecha final
                        </Typography>
                        <Typography className={classes.secondaryHeading}>
                          {doc?.endRefundDate ? doc?.endRefundDate.split(" ")[0] : null}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography className={classes.secondaryHeading}>
                          <Link
                            //href="#"
                            underline="always"
                            style={{
                              color: "#4D8D9D",
                              fontWeight: "500",
                              cursor: "pointer",
                              pointerEvents: "auto",
                            }}
                            onClick={(e) => getFileByDownload(data?.id, doc)}
                          >
                            {doc?.name}
                          </Link>
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        &nbsp;
                      </Grid>
                    </>
                  ))}

                </Grid>
              </div>
            </>
          )}
        </AccordionDetails>
      </Accordion>

      {openModal && (
        <RefundUploadFilesModal
          open={openModal}
          handleClose={onClose}
          setShowMessage={setShowMessage}
          message={message}
          setMessage={setMessage}
          id={data?.id}
          setOpenModal={setOpenModal}
        />
      )}

      {showMessage && <ModalConfirmBase
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        type={message.type}
        open={showMessage}
      />}
    </div>
  );
};

export default React.memo(RefundAccordion);
